import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("first-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="2av1sy62gxl29">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-34" data-mp="38ap4wp5qtw9v">
          <div className="mx-auto max-w-md" data-id="element-35" data-mp="333b0ve8dt8s4">
            <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-navy-900 bg-gold-500 px-5 py-4 text-center text-base font-extrabold uppercase tracking-wide text-navy-900 shadow-[0_10px_30px_rgba(7,18,36,0.35)] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-300 sm:text-lg" data-id="element-36" data-mp="3329faftqp3w5">
              Get the pathway for $27
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-37" data-mp="26da4at1rto09" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}